module.exports = __webpack_public_path__ + "8dc252c8101792fe56a610c76f71d019.svg";